export type PublicStudentIntent =
  | "find-trusted-material"
  | "study-with-toofi"
  | "compare-plans";

export type PublicStudentIntentCard = {
  intent: PublicStudentIntent;
  title: string;
  statement: string;
  reason: string;
  ctaLabel: string;
  href: string;
};

export type PublicStudentEntryStep = {
  title: string;
  detail: string;
};

export const PUBLIC_STUDENT_PRIMARY_NAV = [
  { label: "Features", href: "/features" },
  { label: "Toofi", href: "/toofi" },
  { label: "Pricing", href: "/pricing" },
  { label: "Trusted Resources", href: "/trusted-resources" },
] as const;

export const PUBLIC_STUDENT_INTENTS: PublicStudentIntentCard[] = [
  {
    intent: "find-trusted-material",
    title: "Find trusted material",
    statement: "Start with the resource path if you want clearer academic access first.",
    reason: "This route explains why Athr feels more structured than scattered file sharing.",
    ctaLabel: "See trusted resources",
    href: "/trusted-resources",
  },
  {
    intent: "study-with-toofi",
    title: "Study with Toofi",
    statement: "Start with Toofi if you want to understand the in-flow study help first.",
    reason: "This route shows how Toofi stays close to reading, review, and the next move.",
    ctaLabel: "Explore Toofi",
    href: "/toofi",
  },
  {
    intent: "compare-plans",
    title: "Compare plans",
    statement: "Start with plans if you already know you need the upgrade ladder explained clearly.",
    reason: "This route helps you choose Free, Plus, or Pro without guessing.",
    ctaLabel: "Compare plans",
    href: "/pricing",
  },
] as const;

export const PUBLIC_STUDENT_POST_SIGNUP_STEPS: PublicStudentEntryStep[] = [
  {
    title: "Create your account",
    detail: "Start free and keep the path simple from the first click.",
  },
  {
    title: "Finish onboarding",
    detail: "Set up the account context so Athr can route you into the right study flow.",
  },
  {
    title: "Open your dashboard",
    detail: "Land in the student workspace instead of another generic landing page.",
  },
  {
    title: "Choose the first study action",
    detail: "Continue into reading, Toofi, or the next study path with context in place.",
  },
] as const;
